<!-- <div class="bg-gray-100 font-sans antialiased min-h-screen pb-12">

  <div class="flex flex-col lg:flex-row">
    <div class="flex items-center justify-center mt-5 lg:ml-10 mb-6">
        <img alt="Logo" class="h-24 w-48 lg:h-24 lg:w-60" src="assets/companyLogo.png" />
    </div>
    <div class="flex flex-col lg:flex-row justify-between items-center mb-6 w-full lg:w-full px-4 lg:px-0"> -->
        <!-- Add menu toggle button for desktop -->
        <!-- <div class="lg:ml-80"></div>
        <div class="flex items-center lg:ml-96 lg:mr-8 space-x-8 lg:space-x-10 sm:mt-4 lg:mt-0">
            <i class="fas fa-bell text-purple-700 relative">
                <span class="absolute top-0 right-0 inline-block w-2 h-2 bg-red-600 rounded-full"></span>
            </i>
            <i class="fas fa-envelope text-gray-400"></i>
            <i class="fas fa-user text-gray-400" ></i>
            <i class="fas fa-sign-out-alt text-gray-400 text-xl cursor-pointer" ></i>
            <i class="fas fa-bars text-purple-700 text-xl font-bold " (click)="toggleMenu()">
            </i>
        </div>
    </div>
  </div>

<div class="flex flex-col lg:flex-row">
  <div class="w-full lg:w-80 bg-gray-200 lg:ml-10 shadow-lg p-6" [class.hidden]="!menuOpen">
    <nav class="mt-4 lg:mt-10">
        <a class="flex items-center py-3 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onHomeClick()">
            <i class="fas fa-home text-purple-600"></i>
            <span class="mx-4 font-medium">Home</span>
            <i class="fas fa-caret-down ml-auto"></i>
        </a>
        <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onReportClick()">
            <i class="fas fa-clipboard-list text-purple-600"></i>
            <span class="mx-4 font-medium">Reports</span>
            <i class="fas fa-caret-down ml-auto"></i>        
        </a>
        <a class="flex items-center py-3 mt-4 px-6 border rounded-lg bg-white text-gray-400 hover:shadow-lg cursor-pointer" (click)="onDeviceDetail()">
            <i class="fas fa-calendar-alt text-purple-600"></i>
            <span class="mx-4 font-medium">Device</span>
            <i class="fas fa-caret-down ml-auto"></i>
        </a>
        <a class="flex items-center py-3 px-6 mt-10 lg:mt-56 text-white bg-purple-600 rounded-lg hover:bg-purple-700" href="https://penguinhealth.ca/">
            <i class="fas fa-external-link-alt mx-8"></i>
            <span class="mx-0 font-medium text-center">Visit More</span>
        </a>
    </nav>
</div>
  <div class="flex-1 pl-6  lg:pt-2">
    <div class="bg-gray-200 min-h-screen  sm:pl-10 sm:pr-10 md:px-20  pt-10 lg:pr-8">

      <div class="bg-white flex flex-col lg:flex-row items-center justify-center mainContainer pb-10 pt-10">
        <div class="flex flex-col items-center text-center lg:text-left lg:ml-16">
          <div class="flex items-center mb-4">
            <img alt="Atlas Track Logo" class="mr-2" height="150" src="assets/companyLogo.png" width="250"/>
          </div>
          <img 
  alt="Device Image" 
  class="mb-2 w-3/4 sm:w-2/3 md:w-1/2 lg:w-[250px] lg:h-[200px]" 
  [src]="incubatorModel === 'Atlas Rapid Mini' ? 'assets/deviceDefualt.png' : 'assets/yettouplaod.png'"
/>
          <a class="bg-purple-600 text-white py-2 px-4 rounded-full mt-4" >
            Upload Image
          </a>
        </div>
        <div class="rounded-lg shadow-lg p-6 mt-8 w-full max-w-md lg:ml-32 lg:mr-8" style="background-color: rgba(214, 214, 214, 0.76);">
        
          <div class="mb-4 flex flex-col lg:flex-row items-center">
            <label class="block text-gray-700 w-full lg:w-1/2">Incubator</label>
            <input 
            class="w-full lg:w-2/3 fields p-2 rounded" 
            type="text" 
            [(ngModel)]="incubatorModel"
          />
          </div>
          <div class="mb-4 flex flex-col lg:flex-row items-center">
            <label class="block text-gray-700 w-full lg:w-1/2">Incubator Serial Number</label>
            <input class="w-full lg:w-2/3 fields p-2 rounded" [(ngModel)]="incubatorSerialNumber" value="SN-111 222 333"/>
          </div>
          <div class="mb-4 flex flex-col lg:flex-row items-center">
            <label class="block text-gray-700 w-full lg:w-1/2">BI Type</label>
            <input class="w-full lg:w-2/3 fields p-2 rounded" [(ngModel)]="biType" value="Atlas Rapid AX224"/>
          </div>
          <div class="flex flex-col lg:flex-row items-center justify-between">
            <button class="bg-purple-600 text-white py-2  rounded-full w-full lg:ml-28 lg:mt-4 lg:w-1/2 mb-3" (click)="onServicePackClick()">
              Save
            </button>
           
          </div>
        </div>
      </div>
    
      <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup>
    
    
    </div>
  </div>
</div>

</div> -->


<div class="maincontainer font-sans gap-8">
  <!-- Transparent overlay layer - shown only when settings popup is open -->
  <div *ngIf="showSettings" class="fixed inset-0 bg-opacity-30 z-10" (click)="closeSettings()"></div>
    
  <div class="flex flex-col md:flex-row h-screen">
      <!-- Mobile Header with Menu Toggle -->
      <div class="block md:hidden bg-white p-4 shadow-sm">
          <div class="flex items-center justify-between">
              <img alt="Atlas Track Logo" class="h-8" src="assets/newui/atlasnewlogo.png"/>
              <button class="text-gray-600" (click)="toggleMenu()">
                  <i class="fas fa-bars text-xl"></i>
              </button>
          </div>
      </div>

      <!-- Sidebar - Hidden on mobile by default, shown when toggled -->
      <div class="w-full md:w-80 bg-white p-4   sidebar-menu" [ngClass]="{'hidden': !menuOpen, 'block': menuOpen, 'md:block': true}">
        <div class="flex items-center justify-center h-12 md:h-16 mb-6">
            <img alt="Atlas Track Logo" class="max-w-full h-auto" src="assets/newui/atlasnewlogo.png" width="180"/>
        </div>
        <div class="mt-4 md:mt-10">
            <a class="flex items-center py-2 px-4 md:px-8 hover:bg-purple-50 hover:rounded-lg text-gray-900 hover:text-purple-700 cursor-pointer" (click)="onHomeClick()">
                <i class="fas fa-th-large mr-3"></i>
                <span>Home</span>
            </a>
            
            <!-- Reports Dropdown Menu -->
            <div class="relative">
                <!-- Reports Menu Header -->
                <a class="flex items-center py-2 px-4 md:px-8 text-gray-600 mt-3 hover:bg-purple-50 hover:rounded-lg hover:text-purple-700 cursor-pointer" (click)="toggleReportsDropdown()">
                    <i class="fas fa-file-alt mr-3"></i>
                    <span>Download Reports</span>
                    <i class="fas fa-caret-down ml-auto" [ngClass]="{'transform rotate-180': reportsDropdownOpen}"></i>
                </a>
                
                <!-- Dropdown Items -->
                <div class="pl-8 md:pl-12 overflow-hidden transition-all duration-300" [ngClass]="{'max-h-0': !reportsDropdownOpen, 'max-h-48': reportsDropdownOpen}">
                    <a class="flex  items-center py-3 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onBILOGReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Biological Indicator Report</span>
                    </a>
                    <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onUltrasonicReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Ultrasonic/Washer Report</span>
                    </a>
                    <a class="flex items-center py-2 px-1 text-sm text-gray-600 hover:text-purple-700 cursor-pointer" (click)="onWaterTestReport()">
                        <i class="fas fa-file-alt mr-3"></i>
                        <span>Waterline Test Report</span>
                    </a>
                </div>
            </div>
            
            <a class="flex  items-center py-2 mt-3 px-4 md:px-8 text-gray-600 hover:bg-purple-50 hover:text-purple-700 hover:rounded-lg" (click)="onDeviceDetail()">
                <i class="fas fa-database mr-3"></i>
                <span>Biological Indicator Device</span>
            </a>
        </div>
    </div>
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
          <!-- Header -->
          <header class="flex items-center justify-between h-16 md:h-24 px-4 md:px-6 bg-white shadow-sm md:shadow-none">
              <div class="flex items-center">
                  <h1 class="text-gray-600 text-sm font-medium">
                    Dashboard / Biological Indicator Device
                  </h1>
              </div>
              <div class="flex items-center">
                  <div class="relative">
                  </div>
                  <div class="flex items-center gap-2 md:gap-4">
                      <i class="fas fa-bell text-gray-400 mr-2 md:mr-4"></i>
                  
                      <div class="relative">
                          <div class="flex items-center gap-2 cursor-pointer z-20" (click)="toggleSettings($event)">
                              <img alt="User Avatar" class="rounded-full w-8 h-8 md:w-10 md:h-10" src="assets/newui/demoprofile.png"/>
                              <span class="text-gray-600 hidden sm:inline">{{username}}</span>
                              <i class="fas fa-caret-down ml-auto"></i>
                          </div>
                          
                          <!-- Setting popup with relative positioning and higher z-index -->
                          <div *ngIf="showSettings" class="bg-white shadow-xl rounded-lg p-3 absolute right-0 top-full mt-2 z-20 w-48 md:w-64">
                              <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onManageAccount()">
                                  <img src="assets/newui/icons/manageAccountIcon.png" class="w-4 h-4" alt="">
                                  <p class="text-sm"> Manage Account </p>
                              </div>
                              <hr class="mt-2">
                              <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onForgetPassword()">
                                  <img src="assets/newui/icons/changePasswordIcon.png" class="w-4 h-4 mt-1" alt="">
                                  <p class="text-sm"> Change Password </p>
                              </div>
                              <!-- <hr class="mt-2">
                              <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer">
                                  <img src="assets/newui/icons/activityLogIcon.png" class="w-4 h-4 mt-1" alt="">
                                  <p class="text-sm"> Activity Log </p>
                              </div> -->
                              <hr class="mt-2">
                              <div class="flex gap-3 p-2 hover:bg-gray-100 rounded cursor-pointer" (click)="onLogoutClick()">
                                  <img src="assets/newui/icons/logoutIcon.png" class="w-5 h-4 mt-1" alt="">
                                  <p class="text-sm"> Logout </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </header>
        
      <!-- Main Section -->
      <main class="flex-1 overflow-auto">
        <div class="flex-1">
          <div class="bg-gray-50 min-h-screen px-4 sm:px-10 md:px-16 lg:px-20 pt-6 md:pt-10">
            <p class="text-xl md:text-2xl font-bold mb-3 pl-2">Biological Indicator Device</p>
              
            <div class="bg-white rounded-lg shadow-lg flex flex-col lg:flex-row justify-between p-4 md:p-8 lg:p-24 gap-8">
              <!-- Device Image Section -->
              <div class="flex flex-col rightsectionbg items-center text-center lg:text-left lg:w-1/2">
                <img 
                  alt="Device Image" 
                  class="mb-2 w-3/4 mt-8 sm:w-2/3 md:w-3/4 lg:w-[380px] lg:h-[270px] object-contain" 
                  [src]="incubatorModel === 'Atlas Rapid Mini' ? 'assets/newui/penguinDevice.jpeg' : 'assets/yettouplaod.png'"
                />
                <a class="bgpurple text-white py-2 px-4 rounded-full mt-4 text-sm md:text-base cursor-pointer">
                  Upload Image <span class="ml-2">+</span>
                </a>
              </div>
                
              <!-- Form Section -->
              <div class="rounded-lg p-4 md:p-6 mt-6 lg:mt-0 w-full lg:w-1/2">
                <p class="mb-4 font-bold text-lg">Add Information</p>
                  
                <div class="mb-4">
                  <label class="block text-gray-400 text-sm mb-2">Incubator</label>
                  <input 
                    class="w-full fields p-2 rounded" 
                    type="text" 
                    [(ngModel)]="incubatorModel"
                  />
                </div>
                  
                <div class="mb-4">
                  <label class="block text-gray-400 text-sm mb-2">Incubator Serial Number</label>
                  <input 
                    class="w-full fields p-2 rounded" 
                    [(ngModel)]="incubatorSerialNumber" 
                    value="SN-111 222 333"
                  />
                </div>
                  
                <div class="mb-4">
                  <label class="block text-gray-400 text-sm mb-2">BI Type</label>
                  <input 
                    class="w-full fields p-2 rounded" 
                    [(ngModel)]="biType" 
                    value="Atlas Rapid AX224"
                  />
                </div>
                  
                <div class="flex items-center justify-start">
                  <button 
                    class="bgpurple text-white py-2 px-6 text-sm md:text-base rounded-full w-full sm:w-1/2 md:w-1/3 lg:w-1/4" 
                    (click)="onServicePackClick()"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
    
  <app-notification-popup
    [isOpen]="showPopup"
    [message]="popupMessage"
    [type]="popupType"
    (onClose)="closePopup()">
  </app-notification-popup>
</div>